import angular from 'angular';
import uiRouter from 'angular-ui-router';
import shellComponent from './shell.component';
import ShellService from './shell.service';

let shellModule = angular.module('shell', [
  uiRouter
])

.service('ShellService', ShellService)

.run((ShellService) => {
	"ngInject";

	ShellService.init();
})

.component('shell', shellComponent)

.name;

export default shellModule;



// WEBPACK FOOTER //
// ./client/app/common/layout/shell/shell.js